import {ResourceIconPipe} from "./icon/resource.icon.pipe";
import {ResourceTemplatePipe} from "./template/resource.template.pipe";
import {ResourceMediaPipe} from "./media/resource.media.pipe";
import {i18nModule} from "@config/i18n.module";
import {NgModule} from "@angular/core";
import {HttpModule} from "@angular/http";
import {CommonModule} from "@angular/common";
import {ResourcesModule} from "@resources/resources.module";

import {ResourceMultimediaPipe} from "./image/resource.multimedia.pipe";
// Form
import {FormsModule, ReactiveFormsModule} from "@angular/forms";

import {DigiCerbaCommonModule} from "@digicerba/common";

import {AsiServicesModule, AsiDialogModule} from '@asi-ngtools/lib';

/** liste des components / directive à exporter */
var sharedDeclaration: Array<any> = [
  ResourceMultimediaPipe, ResourceTemplatePipe, ResourceMediaPipe, ResourceIconPipe
];

/** liste des modules à exporter */
var sharedModules: Array<any> = [
  FormsModule, ReactiveFormsModule, CommonModule, ResourcesModule, i18nModule
];

/** Liste des composants interne au module */
var declarations: Array<any> = [
];

/** Liste des services */
var services: Array<any> = [];

/** Liste des composants necessitant la création d'une factory */
var entryComponents: Array<any> = [
];

@NgModule({
  declarations: [...sharedDeclaration, ...declarations, ...entryComponents],
  imports: [DigiCerbaCommonModule.forRoot(), AsiServicesModule, AsiDialogModule, HttpModule, ...sharedModules],
  exports: [DigiCerbaCommonModule, ...sharedDeclaration, ...sharedModules],
  providers: [...services],
  entryComponents: [...entryComponents]
})
export class UtilsModule { }



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-catalogue-examen/digicerba-catalogue-examen-web/src/angular/cerba/src/app/common/utils/utils.module.ts